import { site } from "./settings";

const services = [
  { text: "Przejdź do SOPAB", value: "https://sopab-pilotaz.gunb.gov.pl/" },
  {
    text: "Przejdź do eBudownictwo",
    value: "https://e-budownictwo.gunb.gov.pl/",
  },
  { text: "Przejdź do GUNB", value: "https://gunb.gov.pl" },
  {
    text: "Przejdź do eBudownictwo Wnioski",
    value: "https://wnioski.gunb.gov.pl",
  },
  { text: "Przejdź do CEEB", value: "https://zone.gunb.gov.pl" },
  { text: "Przejdź do eCRUB", value: "https://e-crub.gunb.gov.pl" },
  {
    text: "Przejdź do eWykonania Zastępcze",
    value: "https://e-wykonaniazastepcze.gunb.gov.pl",
  },
  { text: "Przejdź do SNRWB", value: "https://snrwb.gunb.gov.pl/public/" },
  { text: "Przejdź do RWDZ", value: "https://wyszukiwarka.gunb.gov.pl" },
  { text: "Przejdź do Akademii", value: "https://akademia.gunb.gov.pl" },
];

export const serviceListEDB = [
  { text: "e-dziennikbudowy", value: "current" },
  { text: "Przejdź do cKOB", value: "https://c-kob.gunb.gov.pl" },
  ...services,
];
export const serviceListCkob = [
  { text: "Książka obiektu budowlanego", value: "current" },
  { text: "Przejdź do EDB", value: "https://e-dziennikbudowy.gunb.gov.pl" },
  ...services,
];

const serviceListBySite = {
  EDB: serviceListEDB,
  CKOB: serviceListCkob,
};

export const servicesList = serviceListBySite[site];

export const instructions = [
  {
    text: "Przewodnik dla uczestników procesu budowlanego",
    link:
      "https://www.gunb.gov.pl/sites/default/files/attachment/prowadzenie_elektronicznego_dziennika_budowy_1.1_-_27.02.2023.pdf",
  },
  {
    text: "Przewodnik dla geodetów",
    link:
      "https://www.gunb.gov.pl/sites/default/files/attachment/prowadzenie_elektronicznego_dziennika_budowy_1.1_dla_geodetow.pdf",
  },
  {
    text:
      "Skrócona Instrukcja Użytkownika System EDB wersja dla przedstawiciela organu administracji",
    link:
      "https://www.gunb.gov.pl/sites/default/files/attachment/skrocona_instrukcja_-_graf.pdf",
  },
  // Dokumentacja użytkownika dla wersji www EDB
  {
    text: "Instrukcja wersji www EDB dla uczestnika procesu budowlanego",
    link: "/files/GUNB_EDB_Instrukcja_uzytkownika_1.6_upb.pdf",
  },
  {
    text: "Instrukcja wersji www EDB dla przedstawiciela organu administracji",
    link: "/files/GUNB_EDB_Instrukcja_uzytkownika_1.6_organ.pdf",
  },
  //Dokumentacja użytkownika dla wersji mobilnej EDB na platformę Android
  {
    text:
      "Instrukcja wersji mobilnej EDB na platformę Android dla uczestnika procesu budowlanego",
    link: "/files/GUNB_EDB_Instrukcja_uzytkownika_mob.edb-android-1.6_upb.pdf",
  },
  {
    text:
      "Instrukcja wersji mobilnej EDB na platformę Android dla przedstawiciela organu administracji",
    link:
      "https://e-dziennikbudowy.gunb.gov.pl/files/GUNB_EDB_Instrukcja_uzytkownika_mob.edb-android-1.6_organ.pdf",
  },
  //Dokumentacja użytkownika dla wersji mobilnej EDB na platformę iOS
  {
    text:
      "Instrukcja wersji mobilnej EDB na platformę iOS dla uczestnika procesu budowlanego",
    link: "/files/GUNB_EDB_Instrukcja_uzytkownika_1.6_upb.pdf",
  },
  {
    text:
      "Instrukcja wersji mobilnej EDB na platformę iOS dla przedstawiciela organu administracji",
    link: "/files/GUNB_EDB_Instrukcja_uzytkownika_1.6_organ.pdf",
  },
];
